import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, forwardRef, inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { UntilDestroy } from '@ngneat/until-destroy';
import { I18NextPipe } from 'angular-i18next';
import { SmartSearchKeywordDirective, SmartSearchState } from 'mbs-ui-kit';
import { LicensesSignalFacade } from 'mbs-ui-shared@facades/licenses-signal.facade';
import { SmartSearchTemplateName } from 'mbs-ui-shared@modules/smart-search-templates/models/smart-search-templates-models';
import { map } from 'rxjs';
import { SmartSearchBaseTemplateComponent } from '../base-template/smart-search-base-template.component';

const excludedLicenseTypes = [
  6, // UnixAgent
  8, // MAC
  12, // MBSCustomSSLCertificate
  13, // Box
  14, // Dedup
  15, // DriveDesktop
  16, // DriveServer
  17, // Gapps
  19, // Rebranding
  20, // RebrandingAndSSL
  21, // RemoteDesktop
  23, // RMM
  24, // SharePoint
  25 // PremiumSupport
];

@UntilDestroy()
@Component({
  selector: 'mbs-smart-search-license-types-template',
  templateUrl: '../base-template/smart-search-base-template.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  providers: [{ provide: SmartSearchKeywordDirective, useExisting: forwardRef(() => SmartSearchLicenseTypesTemplateComponent) }],
  imports: [CommonModule]
})
export class SmartSearchLicenseTypesTemplateComponent extends SmartSearchBaseTemplateComponent {
  i18nPipe: I18NextPipe;
  licenseFacade = inject(LicensesSignalFacade);
  types = toObservable(this.licenseFacade.licenseTypesWithDisplayNamePrePostByOwnerForComputer);

  public tag = SmartSearchTemplateName.LicenseType;
  constructor() {
    const i18nPipe = inject(I18NextPipe);

    super();

    this.i18nPipe = i18nPipe;
  }

  public items = (state: SmartSearchState) =>
    this.types.pipe(
      map((values) =>
        values
          .filter((value) => (value.displayName ?? '').toLowerCase().includes((state.leftCaretClearValue ?? '').toLowerCase()))
          .filter((value) => !excludedLicenseTypes.includes(value.type as number))
          .map((value) => ({
            value: (value.type as number).toString(),
            searchText: value.displayName,
            translation: null
          }))
      )
    );
}
